module.exports = __webpack_public_path__ + "static/media/MM.62780d15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MM.svg
// module id = 2210
// module chunks = 7